import { ISchema, PaywallComponentProps } from '../@types'

type Accent = 'green' | 'rose'

/**
 * Appends the self-contained `PaywallSmallFallbackModal` overlay to the control paywall. The overlay
 * renders on top of the control layout when the discount-on-abort offer is accepted (it self-gates
 * on `applyDiscountOnAbort`), so the control `order` is left untouched — no re-sorting, no per-item
 * `show()` predicates. The overlay reuses the funnel's own plan-picker + money-back config.
 */
export const buildSmallFallbackPaywall = (schema: ISchema, accent: Accent): ISchema => {
	const components = schema.components ?? {}
	const planPickerComponent = components.PaywallPlanPickerComp ? 'PaywallPlanPickerComp' : 'PaywallPlanPicker'

	return {
		...schema,
		// The overlay is the new paywall after the offer — don't also auto-jump to billing.
		config: schema.config && { ...schema.config, showBillingModalAfterFallback: false },
		order: [
			...(schema.order ?? []),
			[
				'PaywallSmallFallbackModal',
				(args): PaywallComponentProps.SmallFallbackModal => ({
					accent,
					planPickerComponent,
					planPicker: components[planPickerComponent]?.(args),
					moneyback: components.PaywallFooterWithMoneyback?.(args),
					ctaText: args.$t('common.controls.get_my_plan'),
				}),
			],
		],
	}
}

/**
 * web_small_fallback_paywall — variant B: top red timer + fallback offer banner + compact picker.
 */
export default (schema: ISchema): ISchema => buildSmallFallbackPaywall(schema, 'green')
